import { PortalAuthProvider } from '@nrx/auth-ui';
import { initSentryBrowser } from '@nrx/error-tracking-web';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './app.js';
import { fxPortalAuthConfig, isFxPortalOidcConfigured } from './auth/fx-portal-auth-config.js';
import { MissingLocalEnvPage } from './pages/missing-local-env.js';
import './index.css';

// Sentry must initialise before the app renders (mirrors the backend instrument-first rule).
initSentryBrowser({
  dsn: import.meta.env['VITE_SENTRY_DSN'],
  environment: import.meta.env['VITE_SENTRY_ENVIRONMENT'],
  release: import.meta.env['VITE_SENTRY_RELEASE'],
  app: 'fx-portal',
});

const root = (
  <React.StrictMode>
    {isFxPortalOidcConfigured() ? (
      <PortalAuthProvider {...fxPortalAuthConfig}>
        <App />
      </PortalAuthProvider>
    ) : (
      <MissingLocalEnvPage />
    )}
  </React.StrictMode>
);

ReactDOM.createRoot(document.getElementById('root')!).render(root);
